import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDepartureScheduleRequests, addDepartureScheduleRequest, editDepartureScheduleRequest, deleteDepartureScheduleRequest, getDepartureScheduleRequestByKey } from "../../redux/actions/departureScheduleRequestActions";
import CreateDepartureScheduleRequest from "./Popups/CreateDepartureScheduleRequest";
import DepartureScheduleRequestDetails from "./Popups/DepartureScheduleRequestDetails";
import EditDepartureScheduleRequest from "./Popups/EditDepartureScheduleRequest";
import RemoveDepartureScheduleRequest from "./Popups/RemoveDepartureScheduleRequest";

function createData(id, createdAt, name, addressLine, dateOfDeparture, authorComment, performerComment, contractRequest, state) {
    return {id, createdAt, name, addressLine, dateOfDeparture, authorComment, performerComment, contractRequest, state};
}

let rows = [
    createData(1, "12.03.2021 00:00", "abc", "abc", "12.03.2021 00:00", "abc", "abc", null, null),
];
const DepartureScheduleRequestList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("departureScheduleRequestList.tableItem.id")},
        {text: t("departureScheduleRequestList.tableItem.createdAt")},
        {text: t("departureScheduleRequestList.tableItem.name")},
        {text: t("departureScheduleRequestList.tableItem.addressLine")},
        {text: t("departureScheduleRequestList.tableItem.dateOfDeparture")},
        {text: t("departureScheduleRequestList.tableItem.authorComment")},
        {text: t("departureScheduleRequestList.tableItem.performerComment")},
        {text: t("departureScheduleRequestList.tableItem.contractRequest")},
        {text: t("departureScheduleRequestList.tableItem.state")},
        {text: t("departureScheduleRequestList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addDepartureScheduleRequest(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getDepartureScheduleRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }
    
    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getDepartureScheduleRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editDepartureScheduleRequest(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getDepartureScheduleRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteDepartureScheduleRequest(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.departureScheduleRequest);
    if (!localData && state.departureScheduleRequests)
    {
        rows = state.departureScheduleRequests;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getDepartureScheduleRequests(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("departureScheduleRequestList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("departureScheduleRequestList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    createdAt: _.createdAt,
                    name: _.name,
                    addressLine: _.addressLine,
                    dateOfDeparture: _.dateOfDeparture,
                    authorComment: _.authorComment,
                    performerComment: _.performerComment,
                    contractRequest: _.contractRequest?.number,
                    state: _.state?.name,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateDepartureScheduleRequest action={'create'} title={t("departureScheduleRequestList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <DepartureScheduleRequestDetails action={'details'} title={t("departureScheduleRequestList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditDepartureScheduleRequest action={'edit'} title={t("departureScheduleRequestList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveDepartureScheduleRequest action={'remove'} title={t("departureScheduleRequestList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default DepartureScheduleRequestList;
